import { Component, inject, Injector } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Title } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'
import { EditablePopupGeojsonComponent } from '@components/editable-popup-geojson/editable-popup-geojson.component'
import { SearchBarService } from '@components/header-bar/searchbar/searchbar.service'
import { POP_UP_DOM_ELEMENT_NAME } from '@core/constants/constant.data'
import { environment } from '@env/environment'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, MatProgressSpinnerModule],
})
export class AppComponent {
  private readonly _searchBarService = inject(SearchBarService)
  private readonly _titleService = inject(Title)
  private readonly _injector = inject(Injector)
  readonly searchLoading$ = this._searchBarService.searchLoading$
  favIcon = document.querySelector<HTMLLinkElement>('#favicon')

  constructor() {
    this._titleService.setTitle(`${environment.appName} - Toolbox`)
    const favicon = environment.favicon
    if (favicon && this.favIcon) {
      this.favIcon.href = favicon
    }
  }

  ngOnInit(): void {
    this._registerCustomElements()
  }

  private _registerCustomElements(): void {
    if (!customElements.get(POP_UP_DOM_ELEMENT_NAME)) {
      const editablePopup = createCustomElement(EditablePopupGeojsonComponent, {
        injector: this._injector,
      })
      customElements.define(POP_UP_DOM_ELEMENT_NAME, editablePopup)
    }
  }
}
